// removed by extract-text-webpack-plugin
module.exports = {"LogoTitle":"GameTitle__LogoTitle__26IwF","LogoText1":"GameTitle__LogoText1__1CJe0","LogoText2":"GameTitle__LogoText2__36OBF","LogoText3":"GameTitle__LogoText3__HD4vo"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/GameTitle/GameTitle.css
// module id = 243
// module chunks = 0